import axiosInstance from '../variables/api/axiosInstance';

// Longueur minimale avant d'interroger le serveur : en dessous, le serveur
// rendrait de toute facon une reponse vide. Ce n'est pas reimplemente comme
// une regle serveur, seulement respecte cote appel pour ne pas appeler pour
// rien. Source unique : NavBar.js importe cette constante plutot que de
// redefinir 3 de son cote.
export const LONGUEUR_MIN_RECHERCHE = 3;

/**
 * Recherche globale, contextualisee au module courant.
 *
 * Passe par axiosInstance : son intercepteur 401 n'ejecte pas l'agent, il
 * ouvre une re-authentification et rejoue la requete (axiosInstance.js). Une
 * recherche lancee pendant l'expiration d'un jeton ne coupe donc pas la
 * frappe en cours.
 *
 * limiteParType est transmis tel quel si l'appelant le fournit ; le serveur
 * le plafonne a 5 de toute facon, ce n'est pas reimplemente ici. L'omettre
 * laissait l'ecran sans aucune prise sur la taille de son propre panneau.
 *
 * Le signal d'un AbortController est transmis a axios : une requete devenue
 * obsolete pendant que la frappe continue est abandonnee plutot que de
 * revenir dans le desordre et d'ecraser une reponse plus recente.
 */
export function chercher({ q, module, limiteParType, signal } = {}) {
  const terme = (q || '').trim();
  if (terme.length < LONGUEUR_MIN_RECHERCHE) {
    return Promise.resolve({ resultats: [], typesIndisponibles: [], typesNonAutorises: [] });
  }
  return axiosInstance
    .get('/v1/recherche', {
      params: { q: terme, module: module || undefined, limiteParType: limiteParType || undefined },
      signal,
    })
    .then((res) => res.data?.data || { resultats: [], typesIndisponibles: [], typesNonAutorises: [] });
}
